import { IconConfig } from "../types";
import { houseContract } from "../upiIcons/HouseContract";
import { arrowRightLeft } from "./arrows";
import { balloon } from "./Balloon";
import { Bank } from "./Bank";
import { banknote } from "./bankNote";
import { bell } from "./Bell";
import { blueHouse } from "./BlueHouse";
import { BrokerRenegotiation } from "./BrokerRenegotiation";
import { building } from "./Building";
import { calculator } from "./Calculator";
import { commercial } from "./Commercial";
import { Credit } from "./Credit";
import { crossCircle } from "./crossCircle";
import { DropdownChevron } from "./DropdownChevron";
import { email } from "./email";
import { facadeRenovation } from "./FacadeRenovation";
import { filter } from "./Filter";
import { fire } from "./fire";
import { garage } from "./Garage";
import { history } from "./history";
import { hollidayHouse } from "./HollidayHouse";
import { HousePercentage } from "./HousePercentage";
import { houseTree } from "./HouseTree";
import { mainHouse } from "./MainHouse";
import { man } from "./Man";
import { manCry } from "./ManCry";
import { manLocked } from "./ManLocked";
import { mortGageLoan } from "./MortGageLoan";
import { NewProjectStar } from "./NewProjectStar";
import { noteSticky } from "./noteSticky";
import { pencil } from "./pencil";
import { piggyBank } from "./piggyBank";
import { powerOff } from "./powerOff";
import { ProCredit } from "./ProCredit";
import { questionMarkCircle } from "./QuestionMarkCircle";
import { receiptText } from "./ReceiptText";
import { RetreatHouse } from "./RetreatHouse";
import { send } from "./send";
import { signature } from "./signature";
import { suitcase } from "./SuitCase";
import { umbrella } from "./Umbrella";
import { UserCircleCheck } from "./UserCircleCheck";
import { users } from "./users";
import { UsersGroup } from "./UsersGroup";
import { woman } from "./WomanIcon";

export const IconCustomPaths: Record<string, IconConfig> = {
  unpaid: {
    type: 'fill' as const,
    paths: [
      "M512 80c0 18-14.3 34.6-38.4 48c-29.1 16.1-72.5 27.5-122.3 30.9c-3.7-1.8-7.4-3.5-11.3-5C300.6 137.4 248.2 128 192 128c-8.3 0-16.4 .2-24.5 .6l-1.1-.6C142.3 114.6 128 98 128 80c0-44.2 86-80 192-80S512 35.8 512 80zM160.7 161.1c10.2-.7 20.7-1.1 31.3-1.1c62.2 0 117.4 12.3 152.5 31.4C369.3 204.9 384 221.7 384 240c0 4-.7 7.9-2.1 11.7c-4.6 13.2-17 25.3-35 35.5c0 0 0 0 0 0c-.1 .1-.3 .1-.4 .2c0 0 0 0 0 0s0 0 0 0c-.3 .2-.6 .3-.9 .5c-35 19.4-90.8 32-153.6 32c-59.6 0-112.9-11.3-148.2-29.1c-1.9-.9-3.7-1.9-5.5-2.9C14.3 274.6 0 258 0 240c0-34.8 53.4-64.5 128-75.4c10.5-1.5 21.4-2.7 32.7-3.5zM416 240c0-21.9-10.6-39.9-24.1-53.4c28.3-4.4 54.2-11.4 76.2-20.5c16.3-6.8 31.5-15.2 43.9-25.5l0 35.4c0 19.3-16.5 37.1-43.8 50.9c-14.6 7.4-32.4 13.7-52.4 18.5c.1-1.8 .2-3.5 .2-5.3zm-32 96c0 18-14.3 34.6-38.4 48c-1.8 1-3.6 1.9-5.5 2.9C304.9 404.7 251.6 416 192 416c-62.8 0-118.6-12.6-153.6-32C14.3 370.6 0 354 0 336l0-35.4c12.5 10.3 27.6 18.7 43.9 25.5C83.4 342.6 135.8 352 192 352s108.6-9.4 148.1-25.9c7.8-3.2 15.3-6.9 22.4-10.9c6.1-3.4 11.8-7.2 17.2-11.2c1.5-1.1 2.9-2.3 4.3-3.4l0 3.4 0 5.7 0 26.3zm32 0l0-32 0-25.9c19-4.2 36.5-9.5 52.1-16c16.3-6.8 31.5-15.2 43.9-25.5l0 35.4c0 10.5-5 21-14.9 30.9c-16.3 16.3-45 29.7-81.3 38.4c.1-1.7 .2-3.5 .2-5.3zM192 448c56.2 0 108.6-9.4 148.1-25.9c16.3-6.8 31.5-15.2 43.9-25.5l0 35.4c0 44.2-86 80-192 80S0 476.2 0 432l0-35.4c12.5 10.3 27.6 18.7 43.9 25.5C83.4 438.6 135.8 448 192 448z"
    ],
    viewBox: "0 0 576 512"
  },
  alert: {
    type: 'fill' as const,
    paths: [
      "M8 0a8 8 0 1 0 8 8 8 8 0 0 0-8-8m.662 4.215-.119 4.427a.55.55 0 0 1-.542.569.55.55 0 0 1-.542-.569l-.121-4.427A.66.66 0 0 1 8 3.538a.663.663 0 0 1 .662.677M8 11.769a.708.708 0 1 1 .735-.708.715.715 0 0 1-.735.708"
    ],
    viewBox: "0 0 16 16"
  },
  altitude: {
    type: 'fill' as const,
    paths: [
      "M13.988 10.734H.999a1 1 0 0 1-.831-1.549l3.3-4.947a2.2 2.2 0 0 1 2.948-.677l1.057-2.476a1.78 1.78 0 0 1 1.6-1.088 1.83 1.83 0 0 1 1.661.993l4.148 8.3a1 1 0 0 1-.893 1.445Zm-12.616-1.2h12.292l-4-8.008a.57.57 0 0 0-.554-.33.59.59 0 0 0-.533.362L7.355 4.406l1.311 1.312a.6.6 0 0 1-.848.848L6.236 4.985l-.031-.031-.2-.2a1.01 1.01 0 0 0-.805-.287 1 1 0 0 0-.732.44L1.371 9.538Z"
    ]
  },

  arrowDownB: {
    type: 'fill' as const,
    paths: [
      "M5.42 6.945.189 1.717a.646.646 0 0 1 0-.914l.61-.61a.646.646 0 0 1 .913 0l4.165 4.146L10.042.188a.646.646 0 0 1 .913 0l.61.61a.646.646 0 0 1 0 .914L6.334 6.945a.646.646 0 0 1-.914 0"
    ],
    viewBox: "0 0 12 8"
  },

  arrowDownBlack: {
    type: 'stroke' as const,
    paths: [
      "m2.121 2.121 5.07 5.07 5.07-5.07"
    ],
    viewBox: "0 0 15 10"
  },

  arrowDownBlue: {
    type: 'stroke' as const,
    paths: [
      "m1.414 1.414 2.9 2.9 2.9-2.9"
    ],
    viewBox: "0 0 8 6"
  },

  houseCrack: {
    type: 'fill' as const,
    paths: [
      "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1l32 0 0 160.4c0 35.3 28.7 64 64 64l102.3 0-31.3-52.2c-4.1-6.8-2.6-15.5 3.5-20.5L288 368l-60.2-82.8c-10.9-15 8.2-33.5 22.8-22l117.9 92.6c8 6.3 8.2 18.4 .4 24.9L288 448l38.4 64 122.1 0c35.5 0 64.2-28.8 64-64.3l-.7-160.2 32 0z"
    ],
    viewBox: "0 0 576 512"
  },

  arrowDownGray: {
    type: 'fill' as const,
    paths: [
      "M4.61 5.906.161 1.457a.55.55 0 0 1 0-.777L.68.161a.55.55 0 0 1 .776 0l3.546 3.525L8.541.16a.55.55 0 0 1 .776 0l.519.519a.55.55 0 0 1 0 .777l-4.449 4.45a.55.55 0 0 1-.777 0"
    ],
    viewBox: "0 0 10 7"
  },

  arrowLeftBlack: {
    type: 'fill' as const,
    paths: [
      "m10.297 16.29-.888.888a.956.956 0 0 1-1.355 0L.282 9.409a.956.956 0 0 1 0-1.355L8.054.282a.956.956 0 0 1 1.355 0l.888.888a.96.96 0 0 1-.016 1.371l-4.817 4.59h11.49a.957.957 0 0 1 .96.96V9.37a.957.957 0 0 1-.96.96H5.464l4.818 4.59a.954.954 0 0 1 .015 1.37"
    ],
    viewBox: "0 0 17 18"
  },

  arrowLeft: {
    type: 'fill' as const,
    paths: [
      "m8.048 12.732-.694.694a.747.747 0 0 1-1.059 0L.221 7.353a.747.747 0 0 1 0-1.059L6.295.221a.747.747 0 0 1 1.059 0l.694.694a.75.75 0 0 1-.012 1.072L4.27 5.573h15.834a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-.75.75H4.27l3.765 3.587a.745.745 0 0 1 .013 1.072"
    ],
    viewBox: "0 0 21 14"
  },

  arrowRightDark: {
    type: 'fill' as const,
    paths: [
      "m6.356 5.797-4.789 4.789a.59.59 0 0 1-.836 0l-.558-.558a.59.59 0 0 1 0-.835l3.794-3.814L.172 1.567a.59.59 0 0 1 0-.835L.73.174a.59.59 0 0 1 .836 0l4.79 4.787a.59.59 0 0 1 0 .836"
    ],
    viewBox: "0 0 8 12"
  },

  arrowRightW: {
    type: 'fill' as const,
    paths: [
      "m3.947.606.46-.46a.5.5 0 0 1 .7 0l4.03 4.026a.5.5 0 0 1 0 .7l-4.028 4.03a.5.5 0 0 1-.7 0l-.46-.46a.5.5 0 0 1 .008-.711l2.495-2.378H.5a.5.5 0 0 1-.5-.5v-.66a.5.5 0 0 1 .5-.5h5.952l-2.5-2.379a.494.494 0 0 1-.005-.708"
    ],
    viewBox: "0 0 10 10"
  },

  arrowRight: {
    type: 'stroke' as const,
    paths: [
      "M1 5.31h7.793",
      "m5.605 1.414 3.9 3.9-3.9 3.9"
    ],
    viewBox: "0 0 11 11"
  },

  arrowUpBlue: {
    type: 'stroke' as const,
    paths: [
      "m7.222 3.904-2.9-2.9-2.908 2.9"
    ],
    viewBox: "0 0 9 5"
  },

  arrow: {
    type: 'fill' as const,
    paths: [
      "m7.2 1.106.839-.839a.9.9 0 0 1 1.282 0l7.349 7.345a.9.9 0 0 1 0 1.282l-7.347 7.349a.9.9 0 0 1-1.282 0l-.841-.839a.91.91 0 0 1 .015-1.3l4.555-4.34H.907A.905.905 0 0 1 0 8.86V7.653a.905.905 0 0 1 .907-.91h10.865l-4.555-4.34A.9.9 0 0 1 7.2 1.106"
    ],
    viewBox: "0 0 17 17"
  },

  attachmentTabs: {
    type: 'fill' as const,
    paths: [
      "M35.5 34V16c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v18c0 4.69-3.81 8.5-8.5 8.5s-8.5-3.81-8.5-8.5V11c0-3.03 2.47-5.5 5.5-5.5s5.5 2.47 5.5 5.5v21.5a2.5 2.5 0 0 1-5 0V13c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v19.5c0 3.03 2.47 5.5 5.5 5.5s5.5-2.47 5.5-5.5V11c0-4.69-3.81-8.5-8.5-8.5s-8.5 3.81-8.5 8.5v23c0 6.34 5.16 11.5 11.5 11.5S35.5 40.34 35.5 34"
    ],
    viewBox: "0 0 48 48"
  },

  attentionPanel: {
    type: 'fill' as const,
    paths: [
      "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7.2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8.2-40.1l216-368C228.7 39.5 241.8 32 256 32m0 128c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24m32 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0"
    ],
    viewBox: "0 0 512 512"
  },
  balloonLogo: balloon,
  bellNotif: {
    type: 'fill' as const,
    paths: [
      "M1509.102 74.895a2.25 2.25 0 0 0 2.248-2.249h-4.5a2.25 2.25 0 0 0 2.252 2.249m7.569-5.261c-.679-.73-1.949-1.827-1.949-5.422a5.55 5.55 0 0 0-4.492-5.452v-.732a1.124 1.124 0 1 0-2.248 0v.732a5.55 5.55 0 0 0-4.5 5.452c0 3.591-1.271 4.691-1.952 5.422a1.1 1.1 0 0 0-.3.763 1.126 1.126 0 0 0 1.128 1.125h13.487a1.125 1.125 0 0 0 1.128-1.125 1.1 1.1 0 0 0-.3-.763Z"
    ],
    viewBox: "0 0 39 39"
  },

  bellW: {
    type: 'fill' as const,
    paths: [
      "M9.009 20.592a2.574 2.574 0 0 0 2.573-2.574H6.436a2.574 2.574 0 0 0 2.573 2.574m8.663-6.021c-.777-.835-2.231-2.091-2.231-6.205A6.35 6.35 0 0 0 10.3 2.125v-.838a1.286 1.286 0 1 0-2.572 0v.838a6.35 6.35 0 0 0-5.146 6.24c0 4.114-1.454 5.37-2.231 6.205a1.26 1.26 0 0 0-.351.874 1.29 1.29 0 0 0 1.291 1.287h15.436a1.29 1.29 0 0 0 1.291-1.287 1.26 1.26 0 0 0-.346-.873"
    ]
  },

  bgHeader: {
    type: 'fill' as const,
    paths: [
      "M337 0c186.12 0 337 95.338 337 212.943S492.019 323.108 337 425.885 0 330.547 0 212.943 150.88 0 337 0"
    ],
    viewBox: "0 0 674 426"
  },

  brokenWindowCircle: {
    type: 'fill' as const,
    paths: [
      "M1102.33 438.614h15.34v10.141h-15.34Z",
      "M1102.33 447.261h15.34v10.136h-15.34Z",
      "M1102.33 445.611v2.94l1.651-1.289Z",
      "M1102.33 447.261v1.289h2.94l-1.289-1.289Z"
    ],
    viewBox: "0 0 43 43"
  },

  bienCircle: {
    type: 'fill' as const,
    paths: [
      "m480.749 426.167-6.076 5v5.4a.527.527 0 0 0 .527.527l3.693-.01a.527.527 0 0 0 .525-.527v-3.149a.527.527 0 0 1 .527-.527h2.109a.527.527 0 0 1 .527.527v3.152a.527.527 0 0 0 .53.524l3.691.01a.527.527 0 0 0 .527-.527v-5.4l-6.074-5a.4.4 0 0 0-.506 0m9.6 3.4-2.758-2.27v-4.564a.4.4 0 0 0-.4-.4h-1.84a.4.4 0 0 0-.4.4v2.393l-2.95-2.427a1.58 1.58 0 0 0-2.01 0l-8.338 6.869a.4.4 0 0 0-.053.557l.84 1.022a.4.4 0 0 0 .557.054l7.752-6.385a.4.4 0 0 1 .5 0l7.752 6.384a.4.4 0 0 0 .557-.053l.84-1.022a.4.4 0 0 0-.056-.558Z"
    ],
    viewBox: "0 0 34 34"
  },

  brokenWindow: {
    type: 'fill' as const,
    paths: [
      "M2.831 1.284h15.34v10.141H2.831Z",
      "M2.831 9.931h15.34v10.136H2.831Z",
      "M2.831 8.281v2.94l1.651-1.289Z",
      "M2.831 9.931v1.289h2.94L4.482 9.931Z"
    ],
    viewBox: "0 0 21 21"
  },

  building: building,

  bureau: {
    type: 'fill' as const,
    paths: [
      "M54.822 24.111a3.42 3.42 0 0 0-3.416-3.417h-2.519a3.42 3.42 0 0 0-3.417 3.417v11.723a.176.176 0 0 1-.177.177h-1a2.83 2.83 0 0 0-2.514-1.536H29.95v-2.713h5.375a6.68 6.68 0 0 0 6.639-7.418l-2.047-18.4A6.673 6.673 0 0 0 33.278 0H21.545a6.673 6.673 0 0 0-6.639 5.941l-.312 2.8a.876.876 0 1 0 1.741.194l.312-2.8a4.923 4.923 0 0 1 4.9-4.383h11.731a4.923 4.923 0 0 1 4.9 4.383l2.047 18.4a4.93 4.93 0 0 1-4.9 5.473H19.5a4.93 4.93 0 0 1-4.9-5.473l1.348-12.117a.876.876 0 0 0-1.741-.193l-1.348 12.118a6.68 6.68 0 0 0 6.641 7.419h5.376v2.712h-11.83a2.83 2.83 0 0 0-2.514 1.536h-1a.177.177 0 0 1-.177-.177V24.111a3.42 3.42 0 0 0-3.417-3.417H3.417A3.42 3.42 0 0 0 0 24.111a5.094 5.094 0 0 0 4.286 5.023v6.7a5.25 5.25 0 0 0 5.244 5.243h2.427a4.96 4.96 0 0 0 3.243 1.207h9.669v7.686h-8.2a7.29 7.29 0 0 0-7.284 7.284 2.538 2.538 0 0 0 5.077 0 2.21 2.21 0 0 1 2.207-2.208h8.2v2.208a2.538 2.538 0 0 0 5.077 0v-2.208h8.2a2.21 2.21 0 0 1 2.207 2.207 2.538 2.538 0 1 0 5.077 0 7.293 7.293 0 0 0-7.284-7.284h-8.2v-7.685h1.708a.876.876 0 1 0 0-1.752H15.2a3.236 3.236 0 0 1-3.229-3.232 1.076 1.076 0 0 1 1.074-1.074h28.732a1.076 1.076 0 0 1 1.074 1.074 3.236 3.236 0 0 1-3.232 3.232h-4.454a.876.876 0 1 0 0 1.752h4.454a4.96 4.96 0 0 0 3.248-1.206h2.427a5.25 5.25 0 0 0 5.244-5.244v-6.7a5.09 5.09 0 0 0 4.284-5.023"
    ],
    viewBox: "0 0 55 65"
  },

  bullhorn: {
    type: 'fill' as const,
    paths: [
      "M480 32c0-12.9-7.8-24.6-19.8-29.6S434.5.2 425.3 9.3L381.7 53c-48 48-113.1 75-181 75H64c-35.3 0-64 28.7-64 64v96c0 35.3 28.7 64 64 64v128c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V352h8.7c67.9 0 133 27 181 75l43.6 43.6c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V300.4c18.6-8.8 32-32.5 32-60.4s-13.4-51.6-32-60.4zm-64 76.7v262.6C357.2 317.8 280.5 288 200.7 288H192v-96h8.7c79.8 0 156.5-29.8 215.3-83.3"
    ],
    viewBox: "0 0 512 512"
  },

  calculatorGray: {
    type: 'fill' as const,
    paths: [
      "M404.322 0H107.677c-24.813 0-45 20.187-45 45v422c0 24.813 20.187 45 45 45h296.645c24.813 0 45-20.187 45-45V45c0-24.813-20.188-45-45-45M123.77 88.35c0-6.6 5.4-12 12-12h244.473c6.6 0 12 5.4 12 12v45.749c.001 6.6-5.399 12-11.999 12H135.77c-6.6 0-12-5.4-12-12zm146.257 164.045h-28.053c-8.285 0-15-6.716-15-15v-20.383c0-8.284 6.716-15 15-15h28.053c8.284 0 15 6.716 15 15v20.383c0 8.284-6.716 15-15 15m15 61.239v20.383c0 8.284-6.716 15-15 15h-28.053c-8.284 0-15-6.716-15-15v-20.383c0-8.285 6.715-15 15-15h28.053c8.284 0 15 6.716 15 15m-107.22 117.005c0 8.284-6.716 15-15 15h-28.053c-8.284 0-15-6.716-15-15v-20.383c0-8.284 6.716-15 15-15h28.053c8.284 0 15 6.715 15 15zm0-96.622c0 8.284-6.716 15-15 15h-28.053c-8.284 0-15-6.716-15-15v-20.383c0-8.284 6.716-15 15-15h28.053c8.284 0 15 6.716 15 15zm0-96.622c0 8.284-6.716 15-15 15h-28.053c-8.284 0-15-6.716-15-15v-20.383c0-8.284 6.716-15 15-15h28.053c8.284 0 15 6.716 15 15zm214.437 193.244c0 8.284-6.716 15-15 15H241.973c-8.284 0-15-6.716-15-15v-20.383c0-8.285 6.715-15 15-15h135.271c8.284 0 15 6.716 15 15zm0-96.622c0 8.284-6.716 15-15 15h-28.053c-8.284 0-15-6.716-15-15v-20.383c0-8.284 6.716-15 15-15h28.053c8.284 0 15 6.716 15 15zm0-96.622c0 8.284-6.716 15-15 15h-28.053c-8.284 0-15-6.716-15-15v-20.383c0-8.284 6.716-15 15-15h28.053c8.284 0 15 6.716 15 15z"
    ],
    viewBox: "0 0 512 512"
  },

  cementeryCircle: {
    type: 'fill' as const,
    paths: [
      "M1065.437 456.965a1.81 1.81 0 0 1-1.808 1.808h-8.714a2.617 2.617 0 1 1 .82-5.1 2.567 2.567 0 0 1 5.112-.033 10.07 10.07 0 0 1 4.591 3.327Z",
      "M1059.448 455.537v3.24h-4.533a2.617 2.617 0 1 1 .82-5.1 2.57 2.57 0 0 1 1.295-2.013v.571a.443.443 0 0 0 .443.443h.323a.443.443 0 0 1 .443.443v1.533a.443.443 0 0 0 .443.443h.324a.443.443 0 0 1 .442.44",
      "M1055.764 442.883v11.673h-12.091v-11.673a5.864 5.864 0 0 1 5.869-5.869h.354a5.87 5.87 0 0 1 5.868 5.869"
    ],
    viewBox: "0 0 43 43"
  },

  cementery: {
    type: 'fill' as const,
    paths: [
      "M31.437 19.951a1.81 1.81 0 0 1-1.808 1.808h-8.714a2.617 2.617 0 1 1 .82-5.1 2.567 2.567 0 0 1 5.112-.033 10.07 10.07 0 0 1 4.591 3.327Z",
      "M25.448 18.523v3.24h-4.533a2.617 2.617 0 1 1 .82-5.1 2.57 2.57 0 0 1 1.295-2.013v.571a.443.443 0 0 0 .443.443h.323a.443.443 0 0 1 .443.443v1.533a.443.443 0 0 0 .443.443h.324a.443.443 0 0 1 .442.44",
      "M21.764 5.869v11.673H9.673V5.869A5.864 5.864 0 0 1 15.542 0h.354a5.87 5.87 0 0 1 5.868 5.869"
    ],
    viewBox: "0 0 32 22"
  },

  chatNotif: {
    type: 'fill' as const,
    paths: [
      "M1452.914 57.399c5.133 0 9.294 3.381 9.294 7.551s-4.159 7.552-9.294 7.552a12 12 0 0 1-1.449-.092c-2 2-4.379 2.354-6.683 2.407v-.489a3.7 3.7 0 0 0 2.323-2.985 3.5 3.5 0 0 0-.039-.521 7.11 7.11 0 0 1-3.446-5.869c0-4.173 4.161-7.554 9.294-7.554"
    ],
    viewBox: "0 0 39 39"
  },

  chatW: {
    type: 'fill' as const,
    paths: [
      "M9.294 0c5.133 0 9.294 3.381 9.294 7.551s-4.159 7.552-9.294 7.552a12 12 0 0 1-1.449-.092c-2 2-4.379 2.354-6.683 2.407v-.489a3.7 3.7 0 0 0 2.323-2.985 3.5 3.5 0 0 0-.039-.521A7.11 7.11 0 0 1 0 7.554C0 3.381 4.161 0 9.294 0"
    ],
    viewBox: "0 0 19 17"
  },

  chat: {
    type: 'fill' as const,
    paths: [
      "M9.294 0c5.133 0 9.294 3.381 9.294 7.551s-4.159 7.552-9.294 7.552a12 12 0 0 1-1.449-.092c-2 2-4.379 2.354-6.683 2.407v-.489a3.7 3.7 0 0 0 2.323-2.985 3.5 3.5 0 0 0-.039-.521A7.11 7.11 0 0 1 0 7.554C0 3.381 4.161 0 9.294 0"
    ],
    viewBox: "0 0 19 17"
  },

  checkCircleDark: {
    type: 'fill' as const,
    paths: [
      "M7.197 12.038 4.369 9.21a.435.435 0 0 1 0-.615l.616-.615a.435.435 0 0 1 .615 0l1.9 1.9 4.085-4.08a.435.435 0 0 1 .615 0l.615.615a.435.435 0 0 1 0 .615l-5 5a.435.435 0 0 1-.618.008"
    ],
    viewBox: "0 0 17 17"
  },

  circleHouse: {
    type: 'fill' as const,
    paths: [
      "M17.25 18.75h-3a.75.75 0 0 1-.75-.75v-2.25a.75.75 0 0 0-.75-.75h-1.5a.75.75 0 0 0-.75.75V18a.75.75 0 0 1-.75.75h-3A.75.75 0 0 1 6 18v-7.335a.75.75 0 0 1 1.5 0v6.585H9v-1.5a2.25 2.25 0 0 1 2.25-2.25h1.5A2.25 2.25 0 0 1 15 15.75v1.5h1.5v-6.585a.75.75 0 1 1 1.5 0V18a.75.75 0 0 1-.75.75",
      "M18.75 12.75a.75.75 0 0 1-.499-.19L12 7.003 5.749 12.56a.75.75 0 1 1-.998-1.12l6.75-6a.75.75 0 0 1 .998 0l6.75 6a.75.75 0 0 1-.499 1.31"
    ]
  },

  circleOwner: {
    type: 'fill' as const,
    paths: [
      "m133.584 248.876 24.304 6.804a7 7 0 0 0 4.056-.085l132.003-43.014c10.123 11.362 23.791 19.128 38.608 22.128 6.524 28.731 24.508 40.856 41.594 40.856 3.953 0 7.86-.67 11.508-2.03 18.389-6.858 25.274-32.397 15.675-58.143a63 63 0 0 0-1.671-4.017c15.269-18.061 20.97-43.064 13.174-66.984-9.42-28.907-36.16-48.33-66.542-48.33-36.043 0-66.236 27.512-69.7 63.277l-5.544 1.807a7 7 0 0 0-3.327 2.32l-12.74 16.153-19.81-5.547a7 7 0 0 0-7.383 2.406l-12.74 16.153-19.81-5.547a7 7 0 0 0-7.384 2.407L175.78 204.8l-12.534-6.373a7 7 0 0 0-5.34-.416l-13.312 4.337a7 7 0 0 0-4.457 4.398l-11.292 33.13a6.997 6.997 0 0 0 4.739 8.999"
    ],
    viewBox: "0 0 512 512"
  },

  tenantsCircle: {
    type: 'fill' as const,
    paths: [
      "M231 230.128a57.6 57.6 0 1 1 57.6-57.6 57.664 57.664 0 0 1-57.6 57.6m0-99.2a41.6 41.6 0 1 0 41.6 41.6 41.65 41.65 0 0 0-41.6-41.6m100 216.144a8 8 0 0 1-8-8v-19.776A57.36 57.36 0 0 0 265.704 262h-69.408A57.36 57.36 0 0 0 139 319.296v19.776a8 8 0 0 1-16 0v-19.776A73.384 73.384 0 0 1 196.296 246h69.4A73.384 73.384 0 0 1 339 319.296v19.776a8 8 0 0 1-8 8"
    ],
    viewBox: "0 0 462 462"
  },

  circleSign: {
    type: 'fill' as const,
    paths: [
      "M13.076 5.013c.254-.031.591-.018.917.167.504.285.985.78.986 1.521 0 .633-.366 1.142-.682 1.482-.657.71-1.794 1.415-3.012 2.055-.784.412-1.651.823-2.539 1.214a22 22 0 0 0-1.566 2.382c-.698 1.24-1.14 3.379-1.24 4.277a1 1 0 0 1-1.988-.222c.144-1.287.733-3.7 1.485-5.036l.034-.06c-.785.3-1.517.565-2.144.781a1 1 0 0 1-.653-1.89A73 73 0 0 0 7.47 9.826q.342-.44.691-.855c.988-1.175 2.02-2.209 2.912-2.914.441-.349.886-.648 1.302-.835.208-.094.447-.177.7-.209"
    ]
  },

  checkCircle: {
    type: 'stroke' as const,
    paths: [
      "M40.713 19.332v1.8A19.6 19.6 0 1 1 29.087 3.221",
      "m40.713 5.456-19.6 19.624-5.886-5.881"
    ],
    viewBox: "0 0 44 44"
  },

  checkGreen: {
    type: 'fill' as const,
    paths: [
      "m15.038 6.561-.744-.766a.16.16 0 0 0-.118-.051.15.15 0 0 0-.118.051l-5.16 5.2L7.02 9.117a.164.164 0 0 0-.237 0l-.753.753a.17.17 0 0 0 0 .241l2.369 2.369a.75.75 0 0 0 .495.241.8.8 0 0 0 .491-.233l5.659-5.686a.18.18 0 0 0-.006-.241"
    ],
    viewBox: "0 0 20 20"
  },

  checkW: {
    type: 'fill' as const,
    paths: [
      "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7l233.4-233.3c12.5-12.5 32.8-12.5 45.3 0z"
    ],
    viewBox: "0 0 448 512"
  },

  check: {
    type: 'fill' as const,
    paths: [
      "M500.088 83.681c-15.841-15.862-41.564-15.852-57.426 0L184.205 342.148 69.332 227.276c-15.862-15.862-41.574-15.862-57.436 0s-15.862 41.574 0 57.436l143.585 143.585c7.926 7.926 18.319 11.899 28.713 11.899s20.797-3.963 28.723-11.899l287.171-287.181c15.862-15.851 15.862-41.574 0-57.435"
    ],
    viewBox: "0 0 512 512"
  },

  checkCustom: {
    type: 'fill' as const,
    paths: [
      "M500.088 83.681c-15.841-15.862-41.564-15.852-57.426 0L184.205 342.148 69.332 227.276c-15.862-15.862-41.574-15.862-57.436 0s-15.862 41.574 0 57.436l143.585 143.585c7.926 7.926 18.319 11.899 28.713 11.899s20.797-3.963 28.723-11.899l287.171-287.181c15.862-15.851 15.862-41.574 0-57.435"
    ],
    viewBox: "0 0 512 512"
  },
  chevronDown: {
    type: 'fill' as const,
    paths: [
      "M4.905 6.284.171 1.55a.585.585 0 0 1 0-.827L.723.167a.585.585 0 0 1 .826 0l3.77 3.755L9.085.167a.585.585 0 0 1 .826 0l.552.552a.585.585 0 0 1 0 .827L5.732 6.284a.585.585 0 0 1-.827 0"
    ]
  },

  chevronLeft: {
    type: 'fill' as const,
    paths: [
      "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"
    ],
    viewBox: "0 0 320 512"
  },

  chevronRight: {
    type: 'fill' as const,
    paths: [
      "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
    ],
    viewBox: "0 0 320 512"
  },

  circleStar: {
    type: 'fill' as const,
    paths: [
      "M268.945 0C120.368 0 0 120.368 0 268.945S120.368 537.89 268.945 537.89 537.89 417.522 537.89 268.945 417.522 0 268.945 0m168.779 238.465-83.792 79.01 25.58 91.681c5.14 18.527-3.944 25.58-20.56 15.659l-90.007-54.268-90.126 54.147c-16.496 9.921-26.177 2.869-21.516-15.897l24.743-99.689-81.162-71.599c-14.463-12.79-10.519-23.07 8.726-23.07h98.613l46.856-109.012c7.65-17.691 19.842-17.691 27.253.119l45.78 108.893h99.928c19.365.12 23.669 10.877 9.684 24.026"
    ],
    viewBox: "0 0 537.891 537.891"
  },

  clientW: {
    type: 'fill' as const,
    paths: [
      "M18.591 18.657v-1.281a6.92 6.92 0 0 0 3.1-5.757c0-3.85 0-6.971-4.648-6.971s-4.648 3.121-4.648 6.971a6.92 6.92 0 0 0 3.1 5.757v1.281c-5.255.43-9.3 3.012-9.3 6.134h21.691c0-3.122-4.04-5.7-9.3-6.134Zm-10.67.6a14.7 14.7 0 0 1 4.836-1.947 8.7 8.7 0 0 1-.98-1.429 8.9 8.9 0 0 1-1.125-4.258 13.8 13.8 0 0 1 .741-5.659 5.04 5.04 0 0 1 3.854-2.892c-.409-1.851-1.5-3.068-4.4-3.068-4.648 0-4.648 3.121-4.648 6.971a6.92 6.92 0 0 0 3.1 5.757v1.278c-5.255.43-9.3 3.012-9.3 6.134h6.755a10 10 0 0 1 1.167-.892Z"
    ]
  },

  client: {
    type: 'fill' as const,
    paths: [
      "M18.591 18.657v-1.281a6.92 6.92 0 0 0 3.1-5.757c0-3.85 0-6.971-4.648-6.971s-4.648 3.121-4.648 6.971a6.92 6.92 0 0 0 3.1 5.757v1.281c-5.255.43-9.3 3.012-9.3 6.134h21.691c0-3.122-4.04-5.7-9.3-6.134Zm-10.67.6a14.7 14.7 0 0 1 4.836-1.947 8.7 8.7 0 0 1-.98-1.429 8.9 8.9 0 0 1-1.125-4.258 13.8 13.8 0 0 1 .741-5.659 5.04 5.04 0 0 1 3.854-2.892c-.409-1.851-1.5-3.068-4.4-3.068-4.648 0-4.648 3.121-4.648 6.971a6.92 6.92 0 0 0 3.1 5.757v1.278c-5.255.43-9.3 3.012-9.3 6.134h6.755a10 10 0 0 1 1.167-.892Z"
    ]
  },

  clipboardCheckW: {
    type: 'fill' as const,
    paths: [
      "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-37.5C269.4 26.7 233.8 0 192 0m0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64m113 209L177 401c-9.4 9.4-24.6 9.4-33.9 0L79 337c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L271 239c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ],
    viewBox: "0 0 384 512"
  },

  clipboardCheck: {
    type: 'fill' as const,
    paths: [
      "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-37.5C269.4 26.7 233.8 0 192 0m0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64m113 209L177 401c-9.4 9.4-24.6 9.4-33.9 0L79 337c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L271 239c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ],
    viewBox: "0 0 384 512"
  },

  clockRegular: {
    type: 'fill' as const,
    paths: [
      "M221.647 0C99.433 0 0 99.433 0 221.647s99.433 221.647 221.647 221.647 221.647-99.433 221.647-221.647S343.861 0 221.647 0m0 415.588c-106.941 0-193.941-87-193.941-193.941s87-193.941 193.941-193.941 193.941 87 193.941 193.941-87 193.941-193.941 193.941",
      "M235.5 83.118h-27.706v144.265l87.176 87.176 19.589-19.589-79.059-79.059z"
    ],
    viewBox: "0 0 443.294 443.294"
  },

  clockSolid: {
    type: 'fill' as const,
    paths: [
      "M256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512m-24 120v136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24"
    ],
    viewBox: "0 0 512 512"
  },

  closeBlue: {
    type: 'fill' as const,
    paths: [
      "M11.041 1.112 9.929 0 5.52 4.409 1.112 0 0 1.112l4.409 4.409L0 9.929l1.112 1.112 4.409-4.409 4.409 4.409 1.112-1.112L6.633 5.52Z"
    ]
  },

  closeCircleRed: {
    type: 'fill' as const,
    paths: [
      "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-81-337c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9"
    ],
    viewBox: "0 0 512 512"
  },

  closeCircle: {
    type: 'fill' as const,
    paths: [
      "M12.093 11.124 9.84 8.875l2.253-2.248a.682.682 0 1 0-.964-.964L8.88 7.912 6.631 5.663a.682.682 0 0 0-.964.964l2.249 2.249-2.249 2.249a.66.66 0 0 0 0 .964.677.677 0 0 0 .964 0L8.88 9.84l2.249 2.249a.685.685 0 0 0 .964 0 .677.677 0 0 0 0-.965",
      "M8.875 1.195a7.677 7.677 0 1 1-5.432 2.248 7.63 7.63 0 0 1 5.432-2.248m0-1.195a8.875 8.875 0 1 0 8.875 8.875A8.874 8.874 0 0 0 8.875 0"
    ]
  },

  close: {
    type: 'fill' as const,
    paths: [
      "M16.111 1.623 14.489 0 8.056 6.433 1.623 0 0 1.623l6.433 6.433L0 14.489l1.623 1.623 6.433-6.433 6.433 6.433 1.623-1.623-6.433-6.433Z"
    ]
  },

  closeWhite: {
    type: 'fill' as const,
    paths: [
      "M16.111 1.623 14.489 0 8.056 6.433 1.623 0 0 1.623l6.433 6.433L0 14.489l1.623 1.623 6.433-6.433 6.433 6.433 1.623-1.623-6.433-6.433Z"
    ]
  },

  commerce: {
    type: 'fill' as const,
    paths: [
      "M9.608 24.62a.75.75 0 0 0-.75.75v10.734a.75.75 0 0 0 .75.75h17.491a.75.75 0 0 0 .75-.75V25.37a.75.75 0 0 0-.75-.75Zm16.741 10.734H10.358V26.12h15.991Z",
      "M9.608 24.47h17.491a.9.9 0 0 1 .9.9v10.734a.9.9 0 0 1-.9.9H9.608a.9.9 0 0 1-.9-.9V25.37a.9.9 0 0 1 .9-.9m17.491 12.234a.6.6 0 0 0 .6-.6V25.37a.6.6 0 0 0-.6-.6H9.608a.6.6 0 0 0-.6.6v10.734a.6.6 0 0 0 .6.6ZM10.208 25.97h16.291v9.534H10.208Zm15.991.3H10.508v8.934h15.691Z",
      "M5.29 20.093a5.8 5.8 0 0 0 5.4-2.487 5.99 5.99 0 0 0 10.156.2 5.6 5.6 0 0 0 .81 1.014 6.13 6.13 0 0 0 8.473 0 5.6 5.6 0 0 0 .81-1.014 6 6 0 0 0 10.156-.206 5.92 5.92 0 0 0 7.117 2.069 5.217 5.217 0 0 0 3.22-6.269l-2.7-9.27V.9a.78.78 0 0 0-.8-.75H3.85a.78.78 0 0 0-.8.75v3.242l-2.7 9.266a5.02 5.02 0 0 0 .808 4.41 5.8 5.8 0 0 0 4.132 2.275m10.548-1.069a4.33 4.33 0 0 1-3.2-1.379 3.73 3.73 0 0 1-.945-3.164l1.655-9.5h7.285l-.569 9.8-.031.531a4.085 4.085 0 0 1-4.2 3.707Zm13.12-1.23a4.45 4.45 0 0 1-4.742.914 3.93 3.93 0 0 1-2.551-3.838l.033-.577.536-9.307h7.293l.536 9.307.033.577a3.75 3.75 0 0 1-1.139 2.924Zm10.18-.144a4.4 4.4 0 0 1-4.541 1.172 3.97 3.97 0 0 1-2.851-3.5l-.031-.531-.565-9.802h7.28l1.655 9.495a3.73 3.73 0 0 1-.946 3.166Zm10.155-.679a4.24 4.24 0 0 1-4.272 1.559 3.945 3.945 0 0 1-3.145-3.114l-1.817-10.43h7.256l2.56 8.814a3.6 3.6 0 0 1-.581 3.167ZM4.65 1.65h42.47v1.836H4.65ZM1.903 13.8l2.56-8.814h7.257l-1.121 6.428-.493 2.826-.2 1.171a3.91 3.91 0 0 1-2.724 3 4.32 4.32 0 0 1-4.122-.83A3.65 3.65 0 0 1 1.903 13.8",
      "M25.889 20.674a6.22 6.22 0 0 1-4.339-1.742 6 6 0 0 1-.7-.845 6.155 6.155 0 0 1-10.168-.2 5.7 5.7 0 0 1-1.988 1.7 6.15 6.15 0 0 1-2.824.684q-.298 0-.587-.028a5.93 5.93 0 0 1-4.245-2.336 5.16 5.16 0 0 1-.832-4.541l2.69-9.245V.9A.93.93 0 0 1 3.85 0h44.078a.93.93 0 0 1 .954.9v3.214l2.689 9.25a5.14 5.14 0 0 1-.368 3.8 5.7 5.7 0 0 1-2.939 2.646 6.2 6.2 0 0 1-2.33.454 5.94 5.94 0 0 1-4.832-2.384 6.164 6.164 0 0 1-10.168.2 6 6 0 0 1-.7.845 6.22 6.22 0 0 1-4.345 1.749m-5.047-3.148.128.206a5.5 5.5 0 0 0 .788.987 5.98 5.98 0 0 0 8.262 0 5.5 5.5 0 0 0 .788-.986l.128-.205.127.206a5.75 5.75 0 0 0 5.013 2.631 5.7 5.7 0 0 0 4.885-2.831l.12-.215.136.2a5.62 5.62 0 0 0 4.718 2.445 5.9 5.9 0 0 0 2.215-.429 5.4 5.4 0 0 0 2.785-2.5 4.84 4.84 0 0 0 .347-3.583l-2.7-9.291V.9a.63.63 0 0 0-.654-.6H3.85a.63.63 0 0 0-.651.6v3.263L.494 13.45a4.87 4.87 0 0 0 .785 4.279 5.63 5.63 0 0 0 4.025 2.215c.185.018.374.026.559.026a5.65 5.65 0 0 0 4.7-2.447l.136-.207.12.217a5.68 5.68 0 0 0 4.885 2.839 5.74 5.74 0 0 0 5.013-2.64Zm5.041 1.653a4.6 4.6 0 0 1-1.724-.331 4.09 4.09 0 0 1-2.644-3.986l.578-10.025h7.576l.581 10.024a3.92 3.92 0 0 1-1.183 3.04 4.55 4.55 0 0 1-3.183 1.278ZM22.376 5.136l-.561 9.743a3.79 3.79 0 0 0 2.457 3.69 4.3 4.3 0 0 0 1.613.31 4.25 4.25 0 0 0 2.965-1.192 3.62 3.62 0 0 0 1.1-2.807l-.561-9.744Zm-6.537 14.038a4.47 4.47 0 0 1-3.311-1.424 3.87 3.87 0 0 1-.982-3.291l1.676-9.619h7.57l-.61 10.49a4.235 4.235 0 0 1-4.343 3.844M13.475 5.136l-1.633 9.371a3.57 3.57 0 0 0 .908 3.037 4.17 4.17 0 0 0 3.088 1.33 3.936 3.936 0 0 0 4.046-3.566l.031-.531.56-9.641ZM35.94 19.174a4.6 4.6 0 0 1-1.387-.213 4.1 4.1 0 0 1-2.955-3.632l-.031-.531-.579-9.959h7.568l1.676 9.619a3.87 3.87 0 0 1-.982 3.292l-.261.285v-.028a4.5 4.5 0 0 1-3.049 1.167M31.305 5.139l.591 10.172a3.8 3.8 0 0 0 2.746 3.364 4.3 4.3 0 0 0 1.3.2 4.18 4.18 0 0 0 3.088-1.329l.1-.106a3.56 3.56 0 0 0 .813-2.929l-1.64-9.372ZM45.921 18.77a4.5 4.5 0 0 1-.93-.1 4.08 4.08 0 0 1-3.262-3.235L39.88 4.836h7.547l2.591 8.922a3.74 3.74 0 0 1-.6 3.3 4.34 4.34 0 0 1-3.497 1.712M40.237 5.136l1.787 10.25a3.78 3.78 0 0 0 3.026 2.994 4.2 4.2 0 0 0 .868.09 4.04 4.04 0 0 0 3.252-1.592 3.45 3.45 0 0 0 .558-3.036l-2.526-8.706ZM5.859 18.766a4.4 4.4 0 0 1-2.9-1.071 3.8 3.8 0 0 1-1.2-3.937L4.35 4.836h7.547L10.05 15.437a4.05 4.05 0 0 1-2.826 3.119 4.5 4.5 0 0 1-1.365.21M4.576 5.136 2.05 13.842a3.5 3.5 0 0 0 1.1 3.628 4.1 4.1 0 0 0 2.7 1 4.2 4.2 0 0 0 1.274-.2 3.75 3.75 0 0 0 2.626-2.885l1.791-10.249Zm42.7-1.5H4.504V1.5h42.77Zm-42.47-.3h42.17V1.8H4.804Z",
      "M50.824 42.758h-2.091V21.237a.806.806 0 0 0-1.609 0v21.521h-2.7V24.502a.78.78 0 0 0-.8-.75H33.197a.78.78 0 0 0-.8.75v18.256H4.65V21.245a.78.78 0 0 0-.8-.75.78.78 0 0 0-.8.75v21.513H.95a.78.78 0 0 0-.8.75v3.37a.78.78 0 0 0 .8.75h49.87a.78.78 0 0 0 .8-.75v-3.37a.78.78 0 0 0-.796-.75M34.001 25.252h8.817v17.506h-8.817ZM50.02 46.128H1.759v-1.87H50.02Z",
      "M50.824 47.778H.95a.93.93 0 0 1-.954-.9v-3.37a.93.93 0 0 1 .954-.9h1.946V21.245a.93.93 0 0 1 .954-.9.93.93 0 0 1 .954.9v21.363h27.439V24.502a.93.93 0 0 1 .954-.9h10.426a.93.93 0 0 1 .954.9v18.106h2.4V21.237a.93.93 0 0 1 .954-.9.98.98 0 0 1 .671.26.87.87 0 0 1 .283.64v21.371h1.941a.93.93 0 0 1 .954.9v3.37a.93.93 0 0 1-.956.9M.95 42.908a.63.63 0 0 0-.654.6v3.37a.63.63 0 0 0 .654.6h49.87a.63.63 0 0 0 .654-.6v-3.37a.63.63 0 0 0-.654-.6h-2.237V21.237a.57.57 0 0 0-.188-.421.68.68 0 0 0-.466-.179.63.63 0 0 0-.654.6v21.671h-3V24.502a.63.63 0 0 0-.654-.6H33.197a.63.63 0 0 0-.654.6v18.406H4.504V21.245a.63.63 0 0 0-.654-.6.63.63 0 0 0-.654.6v21.663Zm49.22 3.37H1.609v-2.17H50.17Zm-48.261-.3H49.87v-1.57H1.909Zm41.059-3.07H33.85V25.102h9.117Zm-8.818-.3h8.517V25.402H34.15Z",
      "M14.433 32.699a.833.833 0 0 1-.589-1.421l3.315-3.315a.833.833 0 0 1 1.177 1.177l-3.315 3.315a.83.83 0 0 1-.588.244",
      "M14.433 32.849a.982.982 0 0 1-.695-1.677l3.315-3.315a.983.983 0 0 1 1.39 1.389l-3.315 3.315a.98.98 0 0 1-.695.288m3.315-4.98a.68.68 0 0 0-.483.2l-3.315 3.315a.682.682 0 1 0 .965.965l3.315-3.315a.683.683 0 0 0-.483-1.165Z",
      "M15.433 36.699a.833.833 0 0 1-.589-1.421l3.315-3.315a.833.833 0 0 1 1.177 1.177l-3.315 3.315a.83.83 0 0 1-.588.244",
      "M15.433 36.849a.982.982 0 0 1-.695-1.677l3.315-3.315a.983.983 0 0 1 1.39 1.389l-3.315 3.315a.98.98 0 0 1-.695.288m3.315-4.98a.68.68 0 0 0-.483.2l-3.315 3.315a.682.682 0 1 0 .965.965l3.315-3.315a.683.683 0 0 0-.483-1.165Z"
    ],
    viewBox: "0 0 54 54"
  },

  racimmo: {
    type: 'fill' as const,
    paths: [
      "M8.9409 13.8864H13.6682C14.2591 13.8864 14.653 13.4924 14.653 12.9015C14.653 12.3106 14.2591 11.9167 13.6682 11.9167H8.9409C8.34999 11.9167 7.95605 12.3106 7.95605 12.9015C7.95605 13.4924 8.44848 13.8864 8.9409 13.8864Z",
      "M8.9409 18.1212H13.6682C14.2591 18.1212 14.653 17.7273 14.653 17.1364C14.653 16.5455 14.2591 16.1515 13.6682 16.1515H8.9409C8.34999 16.1515 7.95605 16.5455 7.95605 17.1364C7.95605 17.6288 8.44848 18.1212 8.9409 18.1212Z",
      "M8.9409 22.2576H13.6682C14.2591 22.2576 14.653 21.8636 14.653 21.2727C14.653 20.6818 14.2591 20.2879 13.6682 20.2879H8.9409C8.34999 20.2879 7.95605 20.6818 7.95605 21.2727C7.95605 21.8636 8.44848 22.2576 8.9409 22.2576Z",
      "M17.8044 13.8864H22.5317C23.1226 13.8864 23.5165 13.4924 23.5165 12.9015C23.5165 12.3106 23.1226 11.9167 22.5317 11.9167H17.8044C17.2135 11.9167 16.8196 12.3106 16.8196 12.9015C16.8196 13.4924 17.2135 13.8864 17.8044 13.8864Z",
      "M28.1455 13.8864H32.8728C33.4637 13.8864 33.8576 13.4924 33.8576 12.9015C33.8576 12.3106 33.4637 11.9167 32.8728 11.9167H28.1455C27.5546 11.9167 27.1606 12.3106 27.1606 12.9015C27.1606 13.4924 27.5546 13.8864 28.1455 13.8864Z",
      "M17.8044 18.5151H22.5317C23.1226 18.5151 23.5165 18.1212 23.5165 17.5303C23.5165 16.9394 23.1226 16.5454 22.5317 16.5454H17.8044C17.2135 16.5454 16.8196 16.9394 16.8196 17.5303C16.8196 18.1212 17.2135 18.5151 17.8044 18.5151Z",
      "M48.3347 13.8864H53.062C53.6529 13.8864 54.0468 13.4924 54.0468 12.9015C54.0468 12.3106 53.6529 11.9167 53.062 11.9167H48.3347C47.7438 11.9167 47.3499 12.3106 47.3499 12.9015C47.3499 13.4924 47.8423 13.8864 48.3347 13.8864Z",
      "M39.5696 13.8864H44.2968C44.8878 13.8864 45.2817 13.4924 45.2817 12.9015C45.2817 12.3106 44.8878 11.9167 44.2968 11.9167H39.5696C38.9787 11.9167 38.5847 12.3106 38.5847 12.9015C38.5847 13.4924 38.9787 13.8864 39.5696 13.8864Z",
      "M39.5696 18.5151H44.2968C44.8878 18.5151 45.2817 18.1212 45.2817 17.5303C45.2817 16.9394 44.8878 16.5454 44.2968 16.5454H39.5696C38.9787 16.5454 38.5847 16.9394 38.5847 17.5303C38.5847 18.1212 38.9787 18.5151 39.5696 18.5151Z",
      "M26.3728 28.2651H34.6455C35.2364 28.2651 35.6304 27.8712 35.6304 27.2803C35.6304 26.6894 35.2364 26.2954 34.6455 26.2954H26.3728C25.7819 26.2954 25.3879 26.6894 25.3879 27.2803C25.3879 27.7727 25.7819 28.2651 26.3728 28.2651Z",
      "M48.3347 18.1212H53.062C53.6529 18.1212 54.0468 17.7273 54.0468 17.1364C54.0468 16.5455 53.6529 16.1515 53.062 16.1515H48.3347C47.7438 16.1515 47.3499 16.5455 47.3499 17.1364C47.3499 17.6288 47.8423 18.1212 48.3347 18.1212Z",
      "M48.3347 22.2576H53.062C53.6529 22.2576 54.0468 21.8636 54.0468 21.2727C54.0468 20.6818 53.6529 20.2879 53.062 20.2879H48.3347C47.7438 20.2879 47.3499 20.6818 47.3499 21.2727C47.3499 21.8636 47.8423 22.2576 48.3347 22.2576Z",
      "M55.9181 31.4167V26.2955H58.8727C59.1681 26.2955 59.4636 26.0985 59.6606 25.9015C59.8575 25.6061 59.8575 25.3106 59.8575 25.0151L54.8348 8.56818C54.7363 8.17424 54.3424 7.87878 53.85 7.87878H7.06965C6.67571 7.87878 6.28177 8.17424 6.0848 8.56818L1.06207 25.0151C0.963589 25.3106 1.06207 25.6061 1.25904 25.9015C1.45601 26.197 1.75147 26.2955 2.04692 26.2955H5.19844V47.5682C5.19844 48.1591 5.59238 48.553 6.18329 48.553H38.2893C40.1606 53.2803 44.4939 56.5303 49.5166 57.0227C49.9106 57.0227 50.3045 57.1212 50.6984 57.1212C53.85 57.1212 56.8045 56.0379 59.2666 53.9697C62.0242 51.7045 63.6984 48.4545 63.9939 44.9091C64.5848 39.0985 61.2363 33.6818 55.9181 31.4167ZM7.75904 9.84848H53.1606L57.5924 24.3258H55.0318H39.4712C27.85 12.803 31.8878 16.7424 31.0015 15.8561C30.6075 15.4621 30.1151 15.4621 29.7212 15.7576L27.1606 17.8258L19.4787 24.2273C17.8045 24.2273 25.3878 24.2273 3.42571 24.2273L7.75904 9.84848ZM7.16813 26.2955H19.7742C19.9712 26.2955 20.2666 26.197 20.3651 26.0985L28.6378 19.2045L30.2136 17.9242C31.1 18.7121 27.1606 14.9697 38.3878 26C38.5848 26.197 38.7818 26.2955 39.0772 26.2955H53.9484V30.7273C53.259 30.5303 52.5696 30.4318 51.8803 30.3333C42.9181 29.5455 35.7287 37.7197 37.6984 46.5833H24.3045V37.7197C24.3045 34.6667 21.8424 32.303 18.8878 32.303H16.8196C13.7666 32.303 11.403 34.7651 11.403 37.7197V46.5833H7.16813V26.2955ZM13.2742 46.5833V37.7197C13.2742 35.75 14.85 34.2727 16.7212 34.2727H18.7893C20.759 34.2727 22.2363 35.8485 22.2363 37.7197V46.5833H13.2742ZM62.1227 44.7121C61.5318 51.0152 56.0166 55.6439 49.8121 55.053C45.2818 54.6591 41.4409 51.6061 39.9636 47.2727C37.403 39.5909 43.6075 31.6136 51.7818 32.4015C52.7666 32.5 53.7515 32.697 54.6378 33.0909C59.4636 34.7651 62.5166 39.5909 62.1227 44.7121Z",
      "M57.1984 38.803C57.5924 38.4091 57.5924 37.8182 57.1984 37.4242C56.8045 37.0303 56.2136 37.0303 55.8197 37.4242C55.9181 37.3258 54.3424 38.9015 44.7894 48.3561C44.3954 48.75 44.3954 49.3409 44.7894 49.7348C45.1833 50.1288 45.7742 50.1288 46.1681 49.7348C48.6303 47.2727 57.7893 38.2121 57.1984 38.803Z",
      "M54.9332 44.6136C52.865 44.4167 50.9938 45.9924 50.8953 47.8636C50.6983 49.8333 52.1756 51.6061 54.1453 51.803C56.115 52 57.8877 50.5227 58.0847 48.4545C58.2817 46.6818 56.9029 45.0076 54.9332 44.6136ZM54.3423 49.9318C52.1756 49.7348 52.4711 46.3864 54.7362 46.5833C55.6226 46.6818 56.2135 47.4697 56.115 48.3561C56.115 49.3409 55.3271 50.0303 54.3423 49.9318Z",
      "M47.3499 35.4545C45.2818 35.2576 43.4105 36.8333 43.3121 38.7045C43.1151 40.6742 44.5924 42.447 46.5621 42.6439C48.5318 42.8409 50.3045 41.3636 50.5015 39.2955C50.6984 37.5227 49.3196 35.75 47.3499 35.4545ZM46.759 40.7727C44.5924 40.5758 44.8878 37.2273 47.153 37.4242C48.0393 37.5227 48.6302 38.3106 48.5318 39.197C48.5318 40.1818 47.7439 40.7727 46.759 40.7727Z"
    ],
    viewBox: "0 0 66 65"
  },

  habitations: {
    type: 'fill' as const,
    paths: [
      "M32.935 32.619a.937.937 0 1 0-.664-.275.94.94 0 0 0 .664.275",
      "M42.395 32.619a.939.939 0 1 0-.663-.275.94.94 0 0 0 .663.275",
      "M61.318 32.619a.937.937 0 1 0-.664-.275.94.94 0 0 0 .664.275",
      "M51.856 32.619a.939.939 0 1 0-.663-.275.94.94 0 0 0 .663.275",
      "M32.935 39.996a.937.937 0 1 0-.664-.275.94.94 0 0 0 .664.275",
      "M42.395 39.996a.939.939 0 1 0-.663-.275.94.94 0 0 0 .663.275",
      "M61.318 39.996a.937.937 0 1 0-.664-.275.94.94 0 0 0 .664.275",
      "M51.856 39.996a.939.939 0 1 0-.663-.275.94.94 0 0 0 .663.275",
      "M71.186 38.309v-7.044a7.26 7.26 0 0 0-7.249-7.249H30.315a7.26 7.26 0 0 0-7.249 7.249v7.044a4.957 4.957 0 0 0-2.363 9.017v6.3a3.16 3.16 0 0 0 2.417 3.067v2.163a.94.94 0 0 0 .938.938h4.645a.94.94 0 0 0 .938-.938v-2.077h34.971v2.075a.94.94 0 0 0 .938.938h4.645a.94.94 0 0 0 .938-.938v-2.163a3.16 3.16 0 0 0 2.417-3.067v-6.3a4.957 4.957 0 0 0-2.364-9.015m-40.87-12.42h33.62a5.38 5.38 0 0 1 5.374 5.374v7.236a4.965 4.965 0 0 0-3.532 4.747v1.516H28.474v-1.516a4.965 4.965 0 0 0-3.533-4.747v-7.234a5.38 5.38 0 0 1 5.374-5.374Zm35.233 29.015H28.474v-1.569h37.3v1.569zm.229-3.444H28.474v-4.821h37.3v4.821Zm-43.2 2.165v-6.848a.94.94 0 0 0-.5-.8 3.082 3.082 0 1 1 4.519-2.726v11.657h-2.738a1.28 1.28 0 0 1-1.279-1.279Zm5.186 4.292h-2.769v-1.138h2.77Zm41.492 0h-2.769v-1.138h2.772Zm2.916-11.943a.94.94 0 0 0-.5.8v6.848a1.28 1.28 0 0 1-1.279 1.279h-2.739V43.247a3.082 3.082 0 1 1 4.519 2.726Z",
      "M8.07 10.968a6.33 6.33 0 0 1 6.323-6.323h8.7v.191a4.52 4.52 0 0 0-3.192 4.318v4.524h-1.519v1.807h16.967v-1.807h-1.114V9.732h-1.806v3.946H21.71V9.154a2.713 2.713 0 0 1 2.71-2.71h5.3A2.71 2.71 0 0 1 32.217 8.1l1.664-.7a4.51 4.51 0 0 0-2.836-2.56V3.312A3.316 3.316 0 0 0 27.731 0h-1.324a3.32 3.32 0 0 0-3.278 2.838h-8.736a8.14 8.14 0 0 0-8.13 8.13v47.017H0v1.807h15.492v-1.807H8.07Zm16.831-7.656a1.507 1.507 0 0 1 1.506-1.505h1.325a1.507 1.507 0 0 1 1.505 1.505v1.325h-4.336Z"
    ],
    viewBox: "0 0 75 59"
  },

  contentieux: {
    type: 'fill' as const,
    paths: [
      "M384 32h128c17.7 0 32 14.3 32 32s-14.3 32-32 32H398.4c-5.2 25.8-22.9 47.1-46.4 57.3V448h160c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h160V153.3c-23.5-10.3-41.2-31.6-46.4-57.3H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h128c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32m55.6 288h144.9L512 195.8zm72.4 96c-62.9 0-115.2-34-126-78.9-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8L631.3 305c5.7 9.8 9.3 21.1 6.7 32.1C627.2 382 574.9 416 512 416M126.8 195.8 54.4 320h144.9zM.9 337.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8L246.2 305c5.7 9.8 9.3 21.1 6.7 32.1C242 382 189.7 416 126.8 416S11.7 382 .9 337.1"
    ],
    viewBox: "0 0 640 512"
  },

  copropriete: {
    type: 'fill' as const,
    paths: [
      "M22.936 23.244h-.513v-11.701a.616.616 0 0 0-.616-.616h-8.622a.616.616 0 0 0-.616.616v11.7h-.513a.31.31 0 0 0-.308.309v.513h11.5v-.513a.31.31 0 0 0-.312-.308m-7.903-10.367a.31.31 0 0 1 .308-.308h1.026a.31.31 0 0 1 .308.308v1.027a.31.31 0 0 1-.308.308h-1.026a.31.31 0 0 1-.308-.308Zm0 2.463a.31.31 0 0 1 .308-.308h1.026a.31.31 0 0 1 .308.308v1.027a.31.31 0 0 1-.308.308h-1.026a.31.31 0 0 1-.308-.308Zm1.334 3.8h-1.026a.31.31 0 0 1-.308-.313v-1.023a.31.31 0 0 1 .308-.308h1.026a.31.31 0 0 1 .308.308v1.023a.31.31 0 0 1-.308.311Zm1.95 4.106h-1.642v-2.157a.31.31 0 0 1 .308-.308h1.026a.31.31 0 0 1 .308.308Zm1.642-4.419a.31.31 0 0 1-.308.308h-1.026a.31.31 0 0 1-.308-.308v-1.023a.31.31 0 0 1 .308-.308h1.023a.31.31 0 0 1 .308.308Zm0-2.463a.31.31 0 0 1-.308.308h-1.026a.31.31 0 0 1-.308-.308v-1.023a.31.31 0 0 1 .308-.308h1.023a.31.31 0 0 1 .308.308Zm0-2.463a.31.31 0 0 1-.308.308h-1.026a.31.31 0 0 1-.308-.308v-1.024a.31.31 0 0 1 .308-.308h1.023a.31.31 0 0 1 .308.308Z"
    ],
    viewBox: "0 0 35 35"
  },

  cross: {
    type: 'fill' as const,
    paths: [
      "M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5c-11.3-13.6-31.5-15.4-45.1-4.1S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306l135.4 162.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256z"
    ],
    viewBox: "0 0 384 512"
  },

  dashboardW: {
    type: 'fill' as const,
    paths: [
      "M0 9.59h7.672V0H0Zm0 7.672h7.672v-5.754H0Zm9.59 0h7.672v-9.59H9.59ZM9.59 0v5.754h7.672V0Z"
    ]
  },

  dashboard: {
    type: 'fill' as const,
    paths: [
      "M0 9.59h7.672V0H0Zm0 7.672h7.672v-5.754H0Zm9.59 0h7.672v-9.59H9.59ZM9.59 0v5.754h7.672V0Z"
    ]
  },

  datepickerBlue: {
    type: 'stroke' as const,
    paths: [
      "M2.221 2.457h10.3a1.46 1.46 0 0 1 1.471 1.445v10.112a1.46 1.46 0 0 1-1.474 1.443H2.221A1.46 1.46 0 0 1 .75 14.014V3.902a1.46 1.46 0 0 1 1.471-1.445",
      "M10.311.75v3.417",
      "M4.428.75v3.417",
      "M.75 6.632h13.239"
    ]
  },

  datepickerIcon: {
    type: 'fill' as const,
    paths: [
      "M0 13.414A1.39 1.39 0 0 0 1.388 14.8h10.176a1.39 1.39 0 0 0 1.388-1.388V5.551H0Zm9.251-5.666A.35.35 0 0 1 9.6 7.4h1.156a.35.35 0 0 1 .347.347V8.9a.35.35 0 0 1-.347.347H9.6a.35.35 0 0 1-.349-.347Zm0 3.7A.35.35 0 0 1 9.6 11.1h1.156a.35.35 0 0 1 .347.347V12.6a.35.35 0 0 1-.347.347H9.6a.35.35 0 0 1-.347-.347Zm-3.7-3.7A.35.35 0 0 1 5.9 7.4h1.154a.35.35 0 0 1 .347.347V8.9a.35.35 0 0 1-.347.347H5.9a.35.35 0 0 1-.349-.347Zm0 3.7A.35.35 0 0 1 5.9 11.1h1.154a.35.35 0 0 1 .347.347V12.6a.35.35 0 0 1-.347.347H5.9a.35.35 0 0 1-.347-.347Zm-3.7-3.7A.35.35 0 0 1 2.2 7.4h1.154a.35.35 0 0 1 .347.347V8.9a.35.35 0 0 1-.347.347H2.2a.35.35 0 0 1-.35-.347Zm0 3.7A.35.35 0 0 1 2.2 11.1h1.154a.35.35 0 0 1 .347.347V12.6a.35.35 0 0 1-.347.347H2.2a.35.35 0 0 1-.35-.347Zm9.714-9.6h-1.389V.463A.464.464 0 0 0 9.714 0h-.925a.464.464 0 0 0-.463.463V1.85h-3.7V.463A.464.464 0 0 0 4.163 0h-.925a.464.464 0 0 0-.463.463V1.85H1.388A1.39 1.39 0 0 0 0 3.238v1.388h12.952V3.238a1.39 1.39 0 0 0-1.388-1.388Z"
    ]
  },

  declinedMoney: {
    type: 'fill' as const,
    paths: [
      "M535 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l64 64c4.5 4.5 7 10.6 7 17s-2.5 12.5-7 17l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-174-.2c-13.3 0-24-10.7-24-24s10.7-24 24-24h174.1zM105 377l-23 23h174c13.3 0 24 10.7 24 24s-10.7 24-24 24H81.9l23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 441c-4.5-4.5-7-10.6-7-17s2.5-12.5 7-17l64-64c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM96 64h241.9c-3.7 7.2-5.9 15.3-5.9 24 0 28.7 23.3 52 52 52h117.4c-4 17 .6 35.5 13.8 48.8 20.3 20.3 53.2 20.3 73.5 0l19.3-19.3V384c0 35.3-28.7 64-64 64H302.1c3.7-7.2 5.9-15.3 5.9-24 0-28.7-23.3-52-52-52H138.6c4-17-.6-35.5-13.8-48.8-20.3-20.3-53.2-20.3-73.5 0L32 342.5V128c0-35.3 28.7-64 64-64m64 64H96v64c35.3 0 64-28.7 64-64m384 192c-35.3 0-64 28.7-64 64h64zm-224 32a96 96 0 1 0 0-192 96 96 0 1 0 0 192"
    ],
    viewBox: "0 0 640 512"
  },

  docSearch: {
    type: 'fill' as const,
    paths: [
      "m49.994 52.925-6.081-6.081a13.22 13.22 0 0 0-1.552-15.108v-19.1a2.93 2.93 0 0 0-2.926-2.926h-7.069v-.931a4.51 4.51 0 0 0-4.506-4.506h-1.088V3.207A3.21 3.21 0 0 0 23.565 0h-4.769a3.21 3.21 0 0 0-3.21 3.207v1.067h-1.085a4.51 4.51 0 0 0-4.505 4.505v.928h-7.07A2.93 2.93 0 0 0 0 12.633v45.714a2.93 2.93 0 0 0 2.926 2.926h30.966a.9.9 0 0 0 0-1.792H2.926a1.136 1.136 0 0 1-1.135-1.135V12.633A1.136 1.136 0 0 1 2.926 11.5h7.07v.293a1.53 1.53 0 0 0 1.529 1.529h2.93a.9.9 0 0 0 0-1.792h-2.669V8.779A2.717 2.717 0 0 1 14.5 6.065h13.36a2.717 2.717 0 0 1 2.714 2.714v2.75H18.801a.9.9 0 1 0 0 1.792h12.036a1.53 1.53 0 0 0 1.529-1.529V11.5h7.069a1.136 1.136 0 0 1 1.135 1.135v17.4a13.18 13.18 0 0 0-14.851-1.01.9.9 0 0 0 .91 1.544 11.405 11.405 0 1 1-2.9 2.442.9.9 0 1 0-1.363-1.162 13.195 13.195 0 0 0 16.5 20.051l1.7 1.7v4.744a1.136 1.136 0 0 1-1.135 1.135h-1.215a.9.9 0 0 0 0 1.792h1.219a2.93 2.93 0 0 0 2.926-2.926v-2.951l2.581 2.581a2.053 2.053 0 0 0 2.9 0l2.151-2.151a2.05 2.05 0 0 0 0-2.9ZM17.381 3.207a1.417 1.417 0 0 1 1.415-1.415h4.769a1.417 1.417 0 0 1 1.416 1.416v1.066h-7.6Zm31.346 51.351-2.151 2.151a.26.26 0 0 1-.366 0l-5.817-5.817a13 13 0 0 0 1.343-1.174 13 13 0 0 0 1.174-1.344l5.818 5.818a.26.26 0 0 1-.001.366",
      "M28.654 20.651h7.592a.9.9 0 0 0 0-1.792h-7.592a.9.9 0 0 0 0 1.792",
      "M6.519 20.651h16.572a.9.9 0 1 0 0-1.792H6.519a.9.9 0 0 0 0 1.792",
      "M6.519 24.341h16.572a.9.9 0 0 0 0-1.792H6.519a.9.9 0 0 0 0 1.792",
      "M17.003 27.308a.9.9 0 0 0-.9-.9H6.519a.9.9 0 1 0 0 1.792h9.588a.9.9 0 0 0 .896-.892",
      "M28.654 24.341h7.592a.9.9 0 0 0 0-1.792h-7.592a.9.9 0 0 0 0 1.792",
      "M9.655 36.03a4.357 4.357 0 1 0 4.357 4.357 4.36 4.36 0 0 0-4.357-4.357m0 6.922a2.565 2.565 0 1 1 2.565-2.565 2.57 2.57 0 0 1-2.565 2.565",
      "M9.655 48.112a4.357 4.357 0 1 0 4.357 4.357 4.36 4.36 0 0 0-4.357-4.357m0 6.922a2.565 2.565 0 1 1 2.565-2.565 2.57 2.57 0 0 1-2.565 2.565",
      "M17.047 53.365h4.135a.9.9 0 1 0 0-1.792h-4.134a.9.9 0 0 0 0 1.792Z"
    ]
  },

  documentsWhite: {
    type: 'fill' as const,
    paths: [
      "M35.5 34V16c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v18c0 4.69-3.81 8.5-8.5 8.5s-8.5-3.81-8.5-8.5V11c0-3.03 2.47-5.5 5.5-5.5s5.5 2.47 5.5 5.5v21.5a2.5 2.5 0 0 1-5 0V13c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v19.5c0 3.03 2.47 5.5 5.5 5.5s5.5-2.47 5.5-5.5V11c0-4.69-3.81-8.5-8.5-8.5s-8.5 3.81-8.5 8.5v23c0 6.34 5.16 11.5 11.5 11.5S35.5 40.34 35.5 34"
    ],
    viewBox: "0 0 48 48"
  },

  dotMenu: {
    type: 'fill' as const,
    paths: [
      "M3.119 7.475a1.559 1.559 0 1 1-1.56-1.559 1.56 1.56 0 0 1 1.56 1.559",
      "M3.119 1.559A1.559 1.559 0 1 1 1.559 0a1.56 1.56 0 0 1 1.56 1.559",
      "M3.119 13.391a1.559 1.559 0 1 1-1.56-1.559 1.56 1.56 0 0 1 1.56 1.559"
    ]
  },

  dropdown: {
    type: 'fill' as const,
    paths: [
      "M5.42 6.945.189 1.717a.646.646 0 0 1 0-.914l.61-.61a.646.646 0 0 1 .913 0l4.165 4.146L10.042.188a.646.646 0 0 1 .913 0l.61.61a.646.646 0 0 1 0 .914L6.334 6.945a.646.646 0 0 1-.914 0"
    ]
  },

  duplicate: {
    type: 'stroke' as const,
    paths: [
      "M6.268 5.042h5.519a1.226 1.226 0 0 1 1.226 1.226v5.519a1.226 1.226 0 0 1-1.226 1.226H6.268a1.226 1.226 0 0 1-1.226-1.226V6.268a1.226 1.226 0 0 1 1.226-1.226",
      "M2.59 8.721h-.614A1.226 1.226 0 0 1 .75 7.495V1.976A1.226 1.226 0 0 1 1.976.75h5.519a1.226 1.226 0 0 1 1.226 1.226v.614"
    ]
  },

  editCircle: {
    type: 'fill' as const,
    paths: [
      "M13.483 19.676v1.841h1.841l5.428-5.433-1.84-1.837Zm8.693-5.012a.49.49 0 0 0 0-.692l-1.149-1.148a.49.49 0 0 0-.692 0l-.9.9 1.841 1.841Z"
    ]
  },

  euroIcon: {
    type: 'fill' as const,
    paths: [
      "M14.844 19.173a8.02 8.02 0 0 1-7.125-4.329h7.125V12.37H6.9a7.8 7.8 0 0 1 0-2.474h7.941V7.422H7.719a8.025 8.025 0 0 1 12.357-2.387l2.189-2.189A11.116 11.116 0 0 0 4.354 7.422H0V9.9h3.785a10.4 10.4 0 0 0 0 2.474H0v2.474h4.354a11.116 11.116 0 0 0 17.911 4.577l-2.2-2.189a7.92 7.92 0 0 1-5.22 1.942Z"
    ]
  },

  export: {
    type: 'fill' as const,
    paths: [
      "M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v144H176c-35.3 0-64 28.7-64 64v144H64c-35.3 0-64-28.7-64-64zm384 64H256V0zM200 352h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40h-16c-22.1 0-40-17.9-40-40v-80c0-22.1 17.9-40 40-40m133.1 0H368c8.8 0 16 7.2 16 16s-7.2 16-16 16h-34.9c-7.2 0-13.1 5.9-13.1 13.1 0 5.2 3 9.9 7.8 12l37.4 16.6c16.3 7.2 26.8 23.4 26.8 41.2 0 24.9-20.2 45.1-45.1 45.1H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h42.9c7.2 0 13.1-5.9 13.1-13.1 0-5.2-3-9.9-7.8-12l-37.4-16.6c-16.3-7.2-26.8-23.4-26.8-41.2 0-24.9 20.2-45.1 45.1-45.1m98.9 0c8.8 0 16 7.2 16 16v31.6c0 23 5.5 45.6 16 66 10.5-20.3 16-42.9 16-66V368c0-8.8 7.2-16 16-16s16 7.2 16 16v31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6V368c0-8.8 7.2-16 16-16"
    ],
    viewBox: "0 0 512 512"
  },

  externalLink: {
    type: 'fill' as const,
    paths: [
      "M18 20H6c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h4c.6 0 1 .4 1 1s-.4 1-1 1H6v12h12v-4c0-.6.4-1 1-1s1 .4 1 1v4c0 1.1-.9 2-2 2m2-10c-.6 0-1-.4-1-1V5h-4c-.6 0-1-.4-1-1s.4-1 1-1h5c.6 0 1 .4 1 1v5c0 .6-.4 1-1 1",
      "M13 12c-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l7-7c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-7 7c-.2.2-.4.3-.7.3"
    ]
  },

  eyeCircle: {
    type: 'fill' as const,
    paths: [
      "M1736.929 482.115a7.48 7.48 0 0 0-6.633-4.136 7.48 7.48 0 0 0-6.633 4.136.75.75 0 0 0 0 .68 7.48 7.48 0 0 0 6.633 4.136 7.48 7.48 0 0 0 6.633-4.136.75.75 0 0 0 0-.68m-6.633 3.7a3.357 3.357 0 1 1 3.357-3.357 3.357 3.357 0 0 1-3.357 3.354Zm0-5.595a2.2 2.2 0 0 0-.59.088 1.115 1.115 0 0 1-1.56 1.56 2.233 2.233 0 1 0 2.15-1.648"
    ],
    viewBox: "0 0 39 39"
  },

  eyeSlashCircle: {
    type: 'fill' as const,
    paths: [
      "M1543.75 494.524a3.81 3.81 0 0 1-3.8-3.537l-2.782-2.154a9 9 0 0 0-.975 1.477.86.86 0 0 0 0 .776 8.52 8.52 0 0 0 7.557 4.71 8.3 8.3 0 0 0 2.07-.278l-1.377-1.064a4 4 0 0 1-.691.069Zm8.338 1.544-2.938-2.272a8.8 8.8 0 0 0 2.159-2.712.86.86 0 0 0 0-.776 8.52 8.52 0 0 0-7.559-4.712 8.2 8.2 0 0 0-3.914 1l-3.378-2.611a.425.425 0 0 0-.6.075l-.518.671a.425.425 0 0 0 .075.6l15.635 12.079a.425.425 0 0 0 .6-.075l.522-.671a.425.425 0 0 0-.075-.6Zm-4.879-3.772-1.044-.807a2.518 2.518 0 0 0-3.085-3.241 1.27 1.27 0 0 1 .247.75 1.2 1.2 0 0 1-.041.266l-1.955-1.513a3.78 3.78 0 0 1 2.419-.879 3.824 3.824 0 0 1 3.828 3.824 3.7 3.7 0 0 1-.369 1.6"
    ],
    viewBox: "0 0 39 39"
  },

  fileBlue: {
    type: 'fill' as const,
    paths: [
      "m9.304 4.801-.953-.953-4.768 4.767a2.023 2.023 0 0 0 2.86 2.857l5.722-5.718A3.371 3.371 0 0 0 7.397.987L1.39 6.994l-.013.012a4.702 4.702 0 1 0 6.65 6.648l.012-.013 4.1-4.1-.954-.953-4.1 4.1-.012.012A3.353 3.353 0 1 1 2.33 7.96l.013-.012 6.008-6.006a2.023 2.023 0 1 1 2.861 2.86L5.49 10.521a.674.674 0 1 1-.954-.953z"
    ]
  },

  fileGrey: {
    type: 'fill' as const,
    paths: [
      "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zM112 256h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16m0 64h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16m0 64h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16"
    ],
    viewBox: "0 0 384 512"
  },

  fileSign: {
    type: 'fill' as const,
    paths: [
      "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zM80 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16m0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16m54.2 253.8c-6.1 20.3-24.8 34.2-46 34.2H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h8.2c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.7 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7 15.9 0 30.4 9 37.5 23.2l4.4 8.8H304c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 349z"
    ],
    viewBox: "0 0 384 512"
  },

  fileSubmenu: {
    type: 'fill' as const,
    paths: [
      "M330 150c-19.299 0-35-15.701-35-35V0H116C85.673 0 61 24.673 61 55v402c0 30.327 24.673 55 55 55h280c30.327 0 55-24.673 55-55V150zM143 360h72.72c8.284 0 15 6.716 15 15s-6.716 15-15 15H143c-8.284 0-15-6.716-15-15s6.716-15 15-15m-15-65c0-8.284 6.716-15 15-15h220c8.284 0 15 6.716 15 15s-6.716 15-15 15H143c-8.284 0-15-6.716-15-15m235-95c8.284 0 15 6.716 15 15s-6.716 15-15 15H143c-8.284 0-15-6.716-15-15s6.716-15 15-15z",
      "M325 115c0 2.757 2.243 5 5 5h114.314a54.9 54.9 0 0 0-10.515-13.732l-96.423-91.222a55.1 55.1 0 0 0-12.375-8.825z"
    ],
    viewBox: "0 0 512 512"
  },

  fileUploadBlue: {
    type: 'fill' as const,
    paths: [
      "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0zm192 0v128h128zm-40 408c0 13.3-10.7 24-24 24s-24-10.7-24-24V305.9l-31 31c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31V408z"
    ],
    viewBox: "0 0 384 512"
  },

  filterVertical: {
    type: 'fill' as const,
    paths: [
      "M1486 361h-16v2h16z",
      "M1486 366h-16v2h16z",
      "M1475 355c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2",
      "M1480 360c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2",
      "M1480 365c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2",
      "M1486 356h-16v2h16z"
    ]
  },

  filterPrice: {
    type: 'fill' as const,
    paths: [
      "M17.141 0H.844a.844.844 0 0 0-.6 1.439l6.5 6.5v7.238a.84.84 0 0 0 .36.691l2.81 1.966a.844.844 0 0 0 1.326-.691v-9.2l6.5-6.5A.844.844 0 0 0 17.141 0"
    ]
  },

  garage: garage,

  garantiesIcon: {
    type: 'fill' as const,
    paths: [
      "M20.255 5.2a11.37 11.37 0 0 1 10.17 0 11.37 11.37 0 0 0 10.17 0L35.51 17.913H25.34Z",
      "M54.579 66.292a4.34 4.34 0 0 1-1.271-3.069V51.855a38.75 38.75 0 0 0-17.797-32.6H25.34a38.76 38.76 0 0 0-17.8 32.6v11.368a4.34 4.34 0 0 1-1.271 3.068A4.34 4.34 0 0 0 5 69.361a5.83 5.83 0 0 0 5.83 5.83h39.936c3.22 0 5.085-2.61 5.085-5.83a4.34 4.34 0 0 0-1.271-3.068Z",
      "M30.428 5.202a11.37 11.37 0 0 0-7.956-.819l5.413 13.531h7.628l5.083-12.712a11.37 11.37 0 0 1-10.17 0Z",
      "M55.851 69.361a4.34 4.34 0 0 0-1.271-3.068 4.34 4.34 0 0 1-1.272-3.069V51.855a38.75 38.75 0 0 0-17.798-32.6h-7.627a38.75 38.75 0 0 0-17.8 32.6v11.368a4.34 4.34 0 0 1-1.271 3.068 4.34 4.34 0 0 0-1.269 3.07 5.83 5.83 0 0 0 5.83 5.83h37.393c3.22 0 5.085-2.61 5.085-5.83",
      "M0 9.59h7.672V0H0Zm0 7.672h7.672v-5.754H0Zm9.59 0h7.672v-9.59H9.59ZM9.59 0v5.754h7.672V0Z",
      "M40.598 17.984H25.341a2.543 2.543 0 0 0-2.543 2.543h15.255a2.543 2.543 0 0 0 2.545-2.543",
      "M32.968 35.782A13.967 13.967 0 0 0 21.9 58.291a13.967 13.967 0 0 0 19.593-19.593 13.9 13.9 0 0 0-8.525-2.916",
      "m32.223 47.223 4.494-4.494a1.273 1.273 0 1 0-1.8-1.8l-4.494 4.494-4.492-4.492a1.273 1.273 0 1 0-1.8 1.8l4.494 4.494-4.492 4.492a1.273 1.273 0 1 0 1.8 1.8l4.494-4.494 4.494 4.494a1.273 1.273 0 1 0 1.8-1.8Z"
    ]
  },

  handshake: {
    type: 'fill' as const,
    paths: [
      "m272.2 64.6-51.1 51.1c-15.3 4.2-29.5 11.9-41.5 22.5L153 161.9c-10.2 9.1-23.5 14.1-37.2 14.1H96v128c20.4.6 39.8 8.9 54.3 23.4l35.6 35.6 7 7 27 27c6.2 6.2 16.4 6.2 22.6 0 1.7-1.7 3-3.7 3.7-5.8 2.8-7.7 9.3-13.5 17.3-15.3s16.4.6 22.2 6.5l10.8 10.6c11.6 11.6 30.4 11.6 41.9 0 5.4-5.4 8.3-12.3 8.6-19.4.4-8.8 5.6-16.6 13.6-20.4s17.3-3 24.4 2.1c9.4 6.7 22.5 5.8 30.9-2.6 9.4-9.4 9.4-24.6 0-33.9L340.1 243l-35.8 33c-27.3 25.2-69.2 25.6-97 .9-31.7-28.2-32.4-77.4-1.6-106.5l70.1-66.2C303.2 78.4 339.4 64 377.1 64c36.1 0 71 13.3 97.9 37.2l30.1 26.8H624c8.8 0 16 7.2 16 16v208c0 17.7-14.3 32-32 32h-32c-11.8 0-22.2-6.4-27.7-16h-84.9c-3.4 6.7-7.9 13.1-13.5 18.7-17.1 17.1-40.8 23.8-63 20.1-3.6 7.3-8.5 14.1-14.6 20.2-27.3 27.3-70 30-100.4 8.1-25.1 20.8-62.5 19.5-86-4.1L159 404l-7-7-35.6-35.6c-5.5-5.5-12.7-8.7-20.4-9.3 0 17.6-14.4 31.9-32 31.9H32c-17.7 0-32-14.3-32-32V144c0-8.8 7.2-16 16-16h99.8c2 0 3.9-.7 5.3-2l26.5-23.6C175.5 77.7 211.4 64 248.7 64H259c4.4 0 8.9.2 13.2.6M544 320V176h-48c-5.9 0-11.6-2.2-15.9-6.1l-36.9-32.8C425 120.9 401.5 112 377.1 112c-25.4 0-49.8 9.7-68.3 27.1l-70.1 66.2c-10.3 9.8-10.1 26.3.5 35.7 9.3 8.3 23.4 8.1 32.5-.3l71.9-66.4c9.7-9 24.9-8.4 33.9 1.4s8.4 24.9-1.4 33.9l-.8.8 74.4 74.4c10 10 16.5 22.3 19.4 35.1H544zM64 336a16 16 0 1 0-32 0 16 16 0 1 0 32 0m528 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32"
    ],
    viewBox: "0 0 640 512"
  },

  historyTabs: {
    type: 'fill' as const,
    paths: [
      "M4.543 8.916C5.803 5.465 9.116 3 13 3c4.967 0 9 4.033 9 9s-4.033 9-9 9a9 9 0 0 1-7.794-4.499 1 1 0 0 1 1.731-1.002A7.001 7.001 0 0 0 20 12c0-3.864-3.137-7-7-7a7.01 7.01 0 0 0-6.748 5.132l1.752-1a1 1 0 1 1 .992 1.736l-3.5 2a1 1 0 0 1-1.386-.412l-2-3.903a1 1 0 0 1 1.78-.912zM14 11.586l2.707 2.707a1 1 0 0 1-1.414 1.414l-3-3A1 1 0 0 1 12 12V8a1 1 0 0 1 2 0z"
    ]
  },

  blueHouse: blueHouse,

  investissement: {
    type: 'fill' as const,
    paths: [
      "M19.894,46.519a1.426,1.426,0,0,0,1.424,1.424h25.2a1.426,1.426,0,0,0,1.424-1.424V44.438a1.972,1.972,0,0,0-1.97-1.97H43.708V40.676a.878.878,0,1,0-1.756,0v1.792H38.358V35.542a1.631,1.631,0,0,0-1.63-1.63h-5.62a1.631,1.631,0,0,0-1.63,1.63v6.926H25.885V34.233L33.918,27.3l8.034,6.934v2.627a.878.878,0,1,0,1.756,0V35.131a3.551,3.551,0,0,0,3-6.174l-3-2.592V20.486a1.433,1.433,0,0,0-1.431-1.431h-3a1.433,1.433,0,0,0-1.431,1.431v.822l-1.61-1.39a3.573,3.573,0,0,0-4.642,0l-4.751,4.1-9.137-2.069-.014-.014-1.286-1.164a1.438,1.438,0,0,0-.127-.1V19.248a10.723,10.723,0,0,0,4.21-7.849,4.113,4.113,0,0,0,2.63-7.131l.54-4.534A10.493,10.493,0,0,0,25.244,0h-6.6A10.522,10.522,0,0,0,8.757,6.975a.878.878,0,1,0,1.654.59,8.762,8.762,0,0,1,8.235-5.809h6.6a8.736,8.736,0,0,1,8.675,9.769l-.453,3.806a4.1,4.1,0,0,0-.975-.157,10.759,10.759,0,0,0-.506-2.63,1.426,1.426,0,0,0-1.243-.978,24.054,24.054,0,0,1-12.505-4.82,1.42,1.42,0,0,0-1.59-.1,10.756,10.756,0,0,0-5.24,8.526,4.1,4.1,0,0,0-.982.159l-.453-3.808c-.028-.235-.047-.473-.056-.707a.878.878,0,0,0-1.755.068c.011.281.033.565.067.846l.541,4.54A4.113,4.113,0,0,0,11.405,23.4a10.723,10.723,0,0,0,4.259,7.886v1.374a1.47,1.47,0,0,0-.119.093L14.22,33.91c-.019.017-.036.036-.054.054l-9.2,2.076A5.3,5.3,0,0,0,.876,40.814l-.26,3.8a.878.878,0,0,0,.816.936l.061,0a.878.878,0,0,0,.875-.818l.26-3.8a3.527,3.527,0,0,1,2.726-3.18l8.507-1.92,1.245,7.14a1.417,1.417,0,0,0,.875,1.079,1.417,1.417,0,0,0,1.378-.178l1.067-.791,2.521,3.257-3.229,8.126H10.9V37.532a.878.878,0,0,0-1.756,0v4.935H2.522a.766.766,0,0,1-.764-.818l.358-5.236a.878.878,0,0,0-1.752-.12L.006,41.529a2.522,2.522,0,0,0,2.516,2.694H19.894Zm11.341-10.85H36.6v6.8H31.235Zm8.371-14.858h2.347v4.038l-2.347-2.025Zm-6.861.436a1.806,1.806,0,0,1,2.347,0l10.473,9.039a1.8,1.8,0,0,1-2.347,2.719l-8.726-7.531a.878.878,0,0,0-1.147,0l-8.726,7.531a1.8,1.8,0,0,1-2.347-2.719Zm-11.62,7.71a3.552,3.552,0,0,0,2.06,6.231q.133.01.266.01a3.545,3.545,0,0,0,.677-.066v7.336H22.752V37.532a.878.878,0,0,0-1.756,0v4.935H14.178L10.95,34.34l2.516-3.249,1.077.791a1.426,1.426,0,0,0,2.249-.9l1.25-7.153,7.153,1.62Zm-5.972,1.195-3.944-2.9L15.482,22.3l.9.815Zm5.362-20.515v-4.7a2.358,2.358,0,0,1,0,4.7ZM9.208,19.286a2.362,2.362,0,0,1,2.174-2.35v4.7A2.361,2.361,0,0,1,9.208,19.286Zm3.93,3.407V15.9a9,9,0,0,1,4.211-7.623A25.851,25.851,0,0,0,30.38,13.3a9.052,9.052,0,0,1,.379,2.6v6.795a8.812,8.812,0,1,1-17.622,0Zm8.811,10.693a10.4,10.4,0,0,0,4.577-1.056v.416a1.455,1.455,0,0,0-.153.151h0L21.93,38.049,17.572,32.9a1.43,1.43,0,0,0-.152-.152v-.4A10.4,10.4,0,0,0,21.949,33.386Zm-5.205,8.758-1.227-7.036.932-.815,4.2,4.959Zm5.183-1.654,2.124,1.56-2.1,2.714-2.111-2.726Zm.023,8.086,2.34,5.89h-4.68Zm24.238,9.61H21.65V44.438a.214.214,0,0,1,.214-.214H45.973a.214.214,0,0,1,.214.214Z",
      "M161.927,218.628a6.437,6.437,0,0,0,2.462.493,7.172,7.172,0,0,0,2.533-.483.878.878,0,0,0-.618-1.644,4.868,4.868,0,0,1-3.71.01.878.878,0,1,0-.666,1.625Z",
      "M141.692,151.751a.878.878,0,0,0,.878-.878v-1.264a.878.878,0,0,0-1.756,0v1.264A.878.878,0,0,0,141.692,151.751Z",
      "M220.009,151.751a.878.878,0,0,0,.878-.878v-1.264a.878.878,0,1,0-1.756,0v1.264A.878.878,0,0,0,220.009,151.751Z"
    ]
  },

  principale: {
    type: 'fill' as const,
    paths: [
      "M70.227,27.445l-8.264-5.555a15.52,15.52,0,0,0,.717-1.754A15.251,15.251,0,0,0,53.226.811a14.982,14.982,0,0,0-11.532.755,15.331,15.331,0,0,0-7.94,9.583A5.5,5.5,0,0,0,26.4,13.493l-.417.806a.91.91,0,0,0,1.616.836l.417-.806A3.709,3.709,0,0,1,33.356,13a15.324,15.324,0,0,0,.02,4.707,4.721,4.721,0,0,0-1.66,1.831,4.809,4.809,0,0,0,1.991,6.43,4.68,4.68,0,0,0,6.363-2.025,4.8,4.8,0,0,0-4.953-6.908,13.5,13.5,0,0,1-.041-3.129l9.818,5.174a3.736,3.736,0,0,1,1.526,4.966l-4.295,8.3a3.68,3.68,0,0,1-2.2,1.831L32.231,36.47a.91.91,0,0,0-.548.454L20.069,59.375a.2.2,0,0,1-.137.108l-3.841.822a.2.2,0,0,1-.22-.124l-1.523-3.64a1.331,1.331,0,0,1,.487-.983c2.469-.493,3.292-2,2.249-4.324a4.242,4.242,0,0,1,.984-1.926c2.469-.492,3.292-2,2.249-4.324a4.24,4.24,0,0,1,.984-1.926c2.465-.484,3.292-2.014,2.249-4.324a.234.234,0,0,1,.012-.187L25.968,33.9a.91.91,0,0,0,.056-.7l-2.533-7.681a3.75,3.75,0,0,1,.23-2.881l1.654-3.2a.91.91,0,0,0-1.616-.836L22.1,21.8a5.58,5.58,0,0,0-.342,4.287L24.176,33.4l-2.23,4.311a2.058,2.058,0,0,0-.107,1.643l.47,1.3a.222.222,0,0,1-.139.292l-1.336.356c-1.322.352-2.692,3.019-2.227,4.3l.47,1.3a.222.222,0,0,1-.139.292l-1.336.356c-1.322.352-2.693,3.019-2.227,4.3l.47,1.3a.222.222,0,0,1-.139.292l-1.336.356a2.887,2.887,0,0,0-1.7,3.444l1.522,3.64a2.038,2.038,0,0,0,2.28,1.2l3.841-.822a2.016,2.016,0,0,0,1.372-1.051L33.121,38.1l2.845-.892V48.146a3.166,3.166,0,0,0,3.114,3.175l24.194.015h0a3.2,3.2,0,0,0,3.174-3.148v-2.94a.91.91,0,0,0-1.82-.024v2.94a1.368,1.368,0,0,1-1.354,1.353h0l-6.947,0V40.045a.91.91,0,0,0-.91-.91H47.267a.91.91,0,0,0-.91.91v9.461l-7.275,0a1.324,1.324,0,0,1-1.3-1.331v-11.5l2.656-.745a5.508,5.508,0,0,0,3.3-2.739l1.546-2.989a14.971,14.971,0,0,0,2.586.3,3.838,3.838,0,0,0,4.359,2.635,3.786,3.786,0,0,0,2.429-1.638A3.839,3.839,0,0,0,53.617,26.2a3.739,3.739,0,0,0-2.839-.565,3.875,3.875,0,0,0-3,3.039,13.173,13.173,0,0,1-1.619-.163l1.876-3.626s2.684-1.8,3.527-2.353l13.169,8.945V40.7a.86.86,0,1,0,1.719.024V32.686a3.43,3.43,0,0,0,4.641-.868,3.161,3.161,0,0,0-.865-4.372ZM35.9,18.785A2.991,2.991,0,0,1,38,23.758a13.522,13.522,0,0,1-2.523-4.941l.425-.033Zm.481,5.862a2.815,2.815,0,0,1-1.819-.289,2.988,2.988,0,0,1-.734-4.681A15.236,15.236,0,0,0,36.379,24.647Zm11.8,16.308H54.51v8.556l-6.332,0Zm4.966-10.47a1.979,1.979,0,0,1-1.268.857,2.013,2.013,0,0,1-2.061-.922,15.142,15.142,0,0,0,3.653-.835,2.022,2.022,0,0,1-.324.9Zm-2.007-3.071a1.924,1.924,0,0,1,1.688.468,13.311,13.311,0,0,1-3.133.72,1.709,1.709,0,0,1,1.444-1.188Zm-4.37-9.244a5.4,5.4,0,0,0-1.024-.7L35.405,12.02A13.523,13.523,0,0,1,42.5,3.2a13.173,13.173,0,0,1,10.141-.665,13.428,13.428,0,0,1,8.317,17.019,13.685,13.685,0,0,1-.523,1.309L53.35,16.1a3.134,3.134,0,0,0-3.441,0ZM69.573,30.816a1.354,1.354,0,0,1-1.834.4L52.076,20.678a.91.91,0,0,0-1.009,0l-2.412,1.591a5.572,5.572,0,0,0-.729-2.68l2.98-1.964a1.31,1.31,0,0,1,1.435-.007L69.217,28.959A1.34,1.34,0,0,1,69.573,30.816Z",
      "M57.444,326.771a.945.945,0,0,0,1.227-.389l9.455-18.227a.91.91,0,0,0-1.615-.838l-9.455,18.227A.91.91,0,0,0,57.444,326.771Z"
    ]
  },

  datepicker: {
    type: 'fill' as const,
    viewBox: "0 0 12.952 14.8",
    paths: [
      "M0 13.414A1.39 1.39 0 0 0 1.388 14.8h10.176a1.39 1.39 0 0 0 1.388-1.388V5.551H0Zm9.251-5.666A.35.35 0 0 1 9.6 7.4h1.156a.35.35 0 0 1 .347.347V8.9a.35.35 0 0 1-.347.347H9.6a.35.35 0 0 1-.349-.347Zm0 3.7A.35.35 0 0 1 9.6 11.1h1.156a.35.35 0 0 1 .347.347V12.6a.35.35 0 0 1-.347.347H9.6a.35.35 0 0 1-.347-.347Zm-3.7-3.7A.35.35 0 0 1 5.9 7.4h1.154a.35.35 0 0 1 .347.347V8.9a.35.35 0 0 1-.347.347H5.9a.35.35 0 0 1-.349-.347Zm0 3.7A.35.35 0 0 1 5.9 11.1h1.154a.35.35 0 0 1 .347.347V12.6a.35.35 0 0 1-.347.347H5.9a.35.35 0 0 1-.347-.347Zm-3.7-3.7A.35.35 0 0 1 2.2 7.4h1.154a.35.35 0 0 1 .347.347V8.9a.35.35 0 0 1-.347.347H2.2a.35.35 0 0 1-.35-.347Zm0 3.7A.35.35 0 0 1 2.2 11.1h1.154a.35.35 0 0 1 .347.347V12.6a.35.35 0 0 1-.347.347H2.2a.35.35 0 0 1-.35-.347Zm9.714-9.6h-1.389V.463A.464.464 0 0 0 9.714 0h-.925a.464.464 0 0 0-.463.463V1.85h-3.7V.463A.464.464 0 0 0 4.163 0h-.925a.464.464 0 0 0-.463.463V1.85H1.388A1.39 1.39 0 0 0 0 3.238v1.388h12.952V3.238a1.39 1.39 0 0 0-1.388-1.388Z"
    ] as const
  },

  exclamationPoint: {
    type: 'complex' as const,
    viewBox: "0 0 24 24",
    elements: [
      {
        type: 'g',
        id: "exclamation-group",
        children: [
          {
            type: 'rect',
            id: "exclamation-bar",
            x: 10.5,
            y: 3,
            width: 3,
            height: 12,
            rx: 1.5,
            fill: "currentColor"
          },
          {
            type: 'circle',
            id: "exclamation-dot",
            cx: 12,
            cy: 19,
            r: 1.5,
            fill: "currentColor"
          }
        ]
      }
    ]
  },

  messageQuestionMark: {
    type: 'stroke' as const,
    viewBox: "0 0 24 24",
    paths: [
      "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
      "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3",
      "M12 17h.01"
    ]
  },

  receiptEuro: {
    type: 'stroke' as const,
    viewBox: "0 0 24 24",
    paths: [
      "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z",
      "M8 12h5",
      "M16 9.5a4 4 0 1 0 0 5.2"
    ]
  },

  houseTree: houseTree,
  retreatHouse: RetreatHouse,
  mainHouse: mainHouse,
  hollidayHouse: hollidayHouse,
  facadeRenovation: facadeRenovation,
  mortgageLoan: mortGageLoan,
  questionMarkCircle: questionMarkCircle,
  suitcase: suitcase,
  umbrella: umbrella,
  manLocked: manLocked,
  commercial: commercial,
  man: man,
  woman: woman,
  proCredit: ProCredit,
  credit: Credit,
  newProjectStar: NewProjectStar,
  bank: Bank,
  housePercentage: HousePercentage,
  brokerRenegotiation: BrokerRenegotiation,
  usersGroup: UsersGroup,
  dropdownChevron: DropdownChevron,
  userCircleCheck: UserCircleCheck,
  bell: bell,
  users: users,
  calculator: calculator,
  filter: filter,
  receiptText: receiptText,
  bankNote: banknote,
  arrowRightLeft: arrowRightLeft,
  send: send,
  email: email,
  fire: fire,
  piggyBank: piggyBank,
  noteSticky: noteSticky,
  history: history,
  pencil: pencil,
  powerOff: powerOff,
  crossCircle: crossCircle,
  houseContract: houseContract,
  signature: signature,
  manCry: manCry,
} as const satisfies Record<string, IconConfig>;
